<template>
    <div class="layout-header">
        <Menubar :model="items" style="font-weight: 600" class="layout-footer">
            <template #start>
                <img
                    alt="logo"
                    src="../../assets/Brasao.png"
                    height="50"
                    class="p-mr-4 logo-menu"
                />
            </template>
        </Menubar>
    </div>
</template>

<script>
export default {
    name: "rodapeExterno",
    props: {
        titulo: String,
    },
    data() {
        return {
            items: [
                {
                    label: "TRANSPARÊNCIA PÚBLICA",
                    command: () => {
                        this.$router.push("/");
                    },
                },
                {
                    label: "LINKS DE ACESSO",
                    command: () => {
                        this.$router.push("/links-externo");
                    },
                },
                {
                    label: "DESPESAS | EXECUÇÃO ORÇAMENTÁRIA",
                    command: () => {
                        this.$router.push("/despesas-orcamentaria");
                    },
                },
                {
                    label: "DESPESAS POR EMPENHO",
                    command: () => {
                        window.open(
                            "https://www.sistemas.pa.gov.br/portaltransparencia/empenho/notas",
                            "_blank"
                        );
                        ////this.$router.push("/despesas-empenho");
                    },
                },
                {
                    label: "DIÁRIAS",
                    command: () => {
                        window.open(
                            "https://www.sistemas.pa.gov.br/portaltransparencia/despesas-diarias/publicas",
                            "_blank"
                        );
                        //this.$router.push("/despesas-diarias");
                    },
                },

                {
                    label: "CHAMAMENTO PÚBLICO",
                    items: [
                        {
                            label: "CHAMAMENTOS ABERTOS",
                            icon: "pi pi-fw pi-plus-circle",
                            command: () => {
                                this.$router.push("/chamamento-aberto");
                            },
                        },
                        {
                            label: "CHAMAMENTOS ENCERRADOS",
                            icon: "pi pi-fw pi-minus-circle",
                            command: () => {
                                this.$router.push("/chamamento-fechado");
                            },
                        },
                    ],
                },
                {
                    label: "PRESTAÇÃO OSS",
                    items: [
                        {
                            label: "ACQUA",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label: "PRONTO SOCORRO DO BENGUI",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutoacqua.org.br/transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HR PÚBLICO DA TRANSAMAZÔNICA- ALTAMIRA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutoacqua.org.br/transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL PÚBLICO DA MULHER SENHORA DE NAZARÉ- HPMSN",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutoacqua.org.br/transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HR PÚBLICO DA TRANSAMAZÔNICA (HRPT)",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutoacqua.org.br/transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "DIRETRIZES",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label:
                                        "HOSPITAL MATERNO INFANTIL DE BARCARENA- HMIB",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutodiretrizes.org.br/hospital-materno-infantil-de-barcarena-dra-anna-turan/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO LESTE- HRPL",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutodiretrizes.org.br/hospital-regional-publico-do-leste/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL ONCOLÓGICO INFANTIL OCTÁVIO LOBO- HOIOL",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutodiretrizes.org.br/hospital-oncologico-infantil-octavio-lobo/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO BAIXO TOCANTINS -SANTA ROSA- HRPBT",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutodiretrizes.org.br/hospital-santa-rosa-portal/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL REGIONAL DE TUCURUÍ",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://institutodiretrizes.org.br/hospital-regional-de-tucurui-portal/",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "ASELC",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label: "HOSPITAL REGIONAL DE CASTANHAL",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://aselc.org.br/carve-out/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL GERAL DE RIO MARIA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://aselc.org.br/carve-out/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO ARAGUAIA - HRPA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://aselc.org.br/carve-out/",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "IDNSH",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO MARAJÓ- HRPM - BREVES",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL JEAN BITAR",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL GERAL DE TAILÂNDIA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO CAETÉS- HRPC",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL METROPOLITANO DE URGÊNCIA E EMERGÊNCIA- HMUE",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "CENTRO INTEGRADO DE INCLUSÃO E REABILITAÇÃO - CIIR",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.indsh.org.br/mural-da-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "INSAÚDE",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label: "HOSPITAL GERAL DE IPIXUNA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.insaude.org.br/transparencias/unidades-para/16/ipixuna-do-para/48",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL REGIONAL DA PA 279",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.insaude.org.br/transparencias/unidades-para/16/hosp-reg-da-pa-279/53",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "MAIS SAÚDE",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label:
                                        "HOSPITAL REGIONAL DO BAIXO AMAZONAS- HRBA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.institutomaissaude.org.br/hrba-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "HOSPITAL ABELARDO SANTOS - HRAS",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.institutomaissaude.org.br/abelardo-santos-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL GERAL PÚBLICO DE CASTELO DOS SONHOS",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.institutomaissaude.org.br/castelo-de-sonhos-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL PÚBLICO DO TAPAJÓS- HRPT- ITAITUBA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.institutomaissaude.org.br/itaiuba-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL MENINO JESUS- ORIXIMINÁ",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.institutomaissaude.org.br/oriximina-transparencia/",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                        {
                            label: "ISSAA",
                            icon: "pi pi-fw pi-minus-circle",
                            items: [
                                {
                                    label:
                                        "HOSPITAL PÚBLICO ESTADUAL GALILEU- HPEG",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/hospital-publico-estadual-galileu",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "POLICLÍNICA POLIMETROPOLITANA",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/poli-metropolitana-policlinicas-do-para",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "POLI-NATEA TUCURUÍ",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/policlinica-natea-lago-de-tucurui",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label:
                                        "HOSPITAL REGIONAL DO SUDESTE DO PARÁ",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/hospital-regional-do-sudeste-do-para-dr-geraldo",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "POLICLÍNICA - MARABÁ",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/policlinica-natea-de-maraba",
                                            "_blank"
                                        );
                                    },
                                },
                                {
                                    label: "POLICLÍNICA NATEA DE SANTARÉM",
                                    icon: "pi pi-fw pi-minus-circle",
                                    command: () => {
                                        window.open(
                                            "https://www.issaa.org.br/unidades-administradas/transparencia/policlinica-natea-de-santarem",
                                            "_blank"
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    },
    created() {},
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.layout-footer {
    background-color: #dddddd;
    box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    animation: go-back 3s;
}

.texto {
    font-size: 1.5rem;
    font-weight: 700;
}

@media screen and (max-width: 576px) {
    .logo-menu {
        display: none;
    }

    .texto {
        font-size: 1.3rem;
        font-weight: 700;
    }
}
/*
@keyframes go-back {
    from {
        transform: translateX(500px);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}*/
</style>
;
